import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Deals: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirecionar para a página de Pipelines
    navigate('/pipelines')
  }, [navigate])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh'
    }}>
      <p>Redirecionando para Pipelines...</p>
    </div>
  )
}

export default Deals
